import type { IconData } from '@stacksjs/iconify-core'

export const chevronCircleUpRightF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M11 9v5a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1H6a1 1 0 1 0 0 2zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10s-4.477 10-10 10\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default chevronCircleUpRightF
